import { render, staticRenderFns } from "./RateCopy.vue?vue&type=template&id=b9f17f3e"
import script from "./RateCopy.vue?vue&type=script&lang=ts"
export * from "./RateCopy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports